import React, {useEffect} from 'react'

const CFBlog = () => {
    useEffect(() => {
        window.location.href = "https://www.blog.causalfunnel.com/"
    }, [])
  return (
    <div></div>
  )
}

export default CFBlog